/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import React from "react";
import { withTranslation } from "react-i18next";
import classes from "../createPackage/createPackage.module.css";
import Input from "../../../component/inputpm";
import { Paper } from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ActivationResourcesTable from "./activationResourcesTable";
import Icon from "@mui/material/Icon";
import { useState } from "react";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const ConfigurationResource = (props) => {
  const { t } = props;
  // Update data
  const updateFulfilmentTableData = (i, e) => {
    props.updateTableFields(i, e, "FULFILMENT");
  };
  const updateActivationTableData = (i, e) => {
    props.updateTableFields(i, e, "ACTIVATION");
  };
  const updateSuspendTableData = (i, e) => {
    props.updateTableFields(i, e, "SUSPEND");
  };
  const updateResumeTableData = (i, e) => {
    props.updateTableFields(i, e, "RESUME");
  };

  // Add new table row
  const addFulfilmentTableRow = () => {
    props.addNewRow("FULFILMENT");
  };
  const addActivationTableRow = () => {
    props.addNewRow("ACTIVATION");
  };
  const addSuspendTableRow = () => {
    props.addNewRow("SUSPEND");
  };
  const addResumeTableRow = () => {
    props.addNewRow("RESUME");
  };

  // Remove table row
  const removeActivationTableRow = (i) => {
    props.removeRow("ACTIVATION", i);
  };
  const removeFulfilmentTableRow = (i) => {
    props.removeRow("FULFILMENT", i);
  };
  const removeSuspendTableRow = (i) => {
    props.removeRow("SUSPEND", i);
  };
  const removeResumeTableRow = (i) => {
    props.removeRow("RESUME", i);
  };

  const [showPasswordFulfilment, togglePasswordTypeFulfilment] =
    useState(false);
  const [showPasswordSuspend, togglePasswordTypeSuspend] = useState(false);
  const [showPasswordResume, togglePasswordTypeResume] = useState(false);
  const [showPasswordActivation, togglePasswordTypeActivation] =
    useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword = (value) => {
    if (value === 1) {
      togglePasswordTypeFulfilment(!showPasswordFulfilment);
    } else if (value === 2) {
      togglePasswordTypeSuspend(!showPasswordSuspend);
    } else if (value === 3) {
      togglePasswordTypeResume(!showPasswordResume);
    } else if (value === 4) {
      togglePasswordTypeActivation(!showPasswordActivation);
    }
  };
  return (
    <Grid container spacing={5}>
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Paper className={classes.componentDialogPaper} elevation={0}>
          <label style={{ fontSize: "14px" }}>
            {t("CONFIGURE_FULFILMENT_RESOURCE")}
          </label>
          <Autocomplete
            options={
              props.readonly
                ? props.selectedFulfilmentResource
                : props.provisioningResources
            }
            onChange={(event, value) =>
              props.selectResource(value, "FULFILMENT")
            }
            size="small"
            getOptionLabel={(option) => option.resourceName}
            value={props.selectedFulfilmentResource}
            style={{ marginTop: "10px" }}
            classes={{
              option: classes.autoCompleteOption,
            }}
            disabled={props.readonly}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("SELECT_FULFILMENT_RESOURCE")}
                variant="outlined"
              />
            )}
          />

          {props.fulfilmentConnectionFields && (
            <>
              <Grid container spacing={2}>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                ></Grid>

                {props.fulfilmentConnectionFields &&
                  Object.keys(props.fulfilmentConnectionFields).map(
                    (key, index) => (
                      <React.Fragment key={index}>
                        <Grid
                          item
                          size={{
                            xs: 12,
                          }}
                        >
                          {index === 0 && (
                            <label style={{ fontSize: "14px" }}>
                              {t("CONNECTION_PARAMETERS")}
                            </label>
                          )}
                          {key.includes("Password") ? (
                            <FormControl
                              variant="outlined"
                              size={"small"}
                              style={{ marginTop: "6px" }}
                              className="custom-select-input"
                            >
                              <InputLabel htmlFor="outlined-adornment-password">
                                {key}
                              </InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-password"
                                type={
                                  showPasswordFulfilment ? "text" : "password"
                                }
                                name={key}
                                value={props.fulfilmentConnectionFields[key]}
                                onChange={(event) =>
                                  props.updateConnectionFields(
                                    event,
                                    "FULFILMENT",
                                  )
                                }
                                disabled={props.readonly}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => handleClickShowPassword(1)}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                    >
                                      {showPasswordFulfilment ? (
                                        <Visibility />
                                      ) : (
                                        <VisibilityOff />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          ) : (
                            <Input
                              name={key}
                              variant={"outlined"}
                              onChange={(event) =>
                                props.updateConnectionFields(
                                  event,
                                  "FULFILMENT",
                                )
                              }
                              placeholder={key}
                              size={"small"}
                              value={props.fulfilmentConnectionFields[key]}
                              style={{ marginTop: "6px" }}
                              disabled={props.readonly}
                            />
                          )}
                        </Grid>
                      </React.Fragment>
                    ),
                  )}

                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                ></Grid>
              </Grid>
            </>
          )}
          {props.fulfilmentTableFields.length > 0 && (
            <Grid container>
              <ActivationResourcesTable
                activationParams={props.fulfilmentTableFields}
                activationParamEditable={props.fulfilmentTableEditable}
                addActivationParam={addFulfilmentTableRow}
                changeActivationParam={updateFulfilmentTableData}
                removeActivationParam={removeFulfilmentTableRow}
                showDefaultValue={props.showDefaultValue}
                type={"Fulfilment"}
                readonly={props.readonly}
              />
            </Grid>
          )}
        </Paper>
      </Grid>
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Paper className={classes.componentDialogPaper} elevation={0}>
          <label style={{ fontSize: "14px" }}>
            {t("CONFIGURE_ACTIVATION_RESOURCE")}
          </label>
          <Autocomplete
            options={
              props.readonly
                ? props.selectedActivationResource
                : props.activationResources
            }
            onChange={(event, value) =>
              props.selectResource(value, "ACTIVATION")
            }
            size="small"
            value={props.selectedActivationResource}
            getOptionLabel={(option) => option.resourceName}
            style={{ marginTop: "10px" }}
            disabled={props.readonly}
            classes={{
              option: classes.autoCompleteOption,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("SELECT_ACTIVATION_RESOURCE")}
                variant="outlined"
              />
            )}
          />
          {props.selectedActivationResource.resourceName ===
            "Provider REST Callback" &&
            props.activationTableEditable && (
              <>
                <Grid container spacing={2}>
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  ></Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <label style={{ fontSize: "14px" }}>
                      {t("IMPORT_SWAGGER_DEFINITION")}
                    </label>
                    {/* <input type="file" id="activationFile" onChange={(event) => props.onActivationFileChange(event)} /> */}
                    <Input
                      name={"activationFile"}
                      onChange={(event) => props.onActivationFileChange(event)}
                      inputProps={{ id: "activationFile" }}
                      className="custom-file-input"
                      source={props.activationFile}
                      disabled={props.readonly}
                      type="file"
                    />
                    <label
                      htmlFor="activationFile"
                      className="input-file-label"
                      style={{ marginTop: "6px" }}
                    >
                      <Icon>attach_file</Icon>
                      <label>
                        {props.activationFile ? (
                          props.activationFile
                        ) : (
                          <span className="input-file-placeholder">
                            {t("CHOOSE_FILE")}
                          </span>
                        )}
                      </label>
                    </label>
                  </Grid>
                </Grid>
              </>
            )}
          {props.activationConnectionFields && (
            <>
              <Grid container spacing={2}>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                ></Grid>

                {props.activationConnectionFields &&
                  Object.keys(props.activationConnectionFields).map(
                    (key, index) => (
                      <React.Fragment key={index}>
                        <Grid
                          item
                          size={{
                            xs: 12,
                          }}
                        >
                          {index === 0 && (
                            <label style={{ fontSize: "14px" }}>
                              {t("CONNECTION_PARAMETERS")}
                            </label>
                          )}
                          {key.includes("Password") ? (
                            <FormControl
                              variant="outlined"
                              size={"small"}
                              style={{ marginTop: "6px" }}
                              className="custom-select-input"
                            >
                              <InputLabel htmlFor="outlined-adornment-password">
                                {key}
                              </InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-password"
                                type={
                                  showPasswordActivation ? "text" : "password"
                                }
                                name={key}
                                value={props.activationConnectionFields[key]}
                                onChange={(event) =>
                                  props.updateConnectionFields(
                                    event,
                                    "ACTIVATION",
                                  )
                                }
                                disabled={props.readonly}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => handleClickShowPassword(4)}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                    >
                                      {showPasswordActivation ? (
                                        <Visibility />
                                      ) : (
                                        <VisibilityOff />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          ) : (
                            <Input
                              name={key}
                              variant={"outlined"}
                              onChange={(event) =>
                                props.updateConnectionFields(
                                  event,
                                  "ACTIVATION",
                                )
                              }
                              placeholder={key}
                              size={"small"}
                              value={props.activationConnectionFields[key]}
                              style={{ marginTop: "6px" }}
                              disabled={props.readonly}
                            />
                          )}
                        </Grid>
                      </React.Fragment>
                    ),
                  )}

                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                ></Grid>
              </Grid>
            </>
          )}
          {/* {props.activationTableFields.length > 0 && */}
          <Grid container>
            <ActivationResourcesTable
              activationParams={props.activationTableFields}
              activationParamEditable={props.activationTableEditable}
              addActivationParam={addActivationTableRow}
              changeActivationParam={updateActivationTableData}
              removeActivationParam={removeActivationTableRow}
              type={"Activation"}
              readonly={props.readonly}
            />
          </Grid>
          {/* } */}
        </Paper>
      </Grid>
      {props.priceType === "RC" && (
        <>
          <Grid
            item
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Paper className={classes.componentDialogPaper} elevation={0}>
              <label style={{ fontSize: "14px" }}>
                {t("CONFIGURE_SUSPEND_RESOURCE")}
              </label>
              <Autocomplete
                options={
                  props.readonly
                    ? props.selectedSuspendResource
                    : props.suspendResources
                }
                onChange={(event, value) =>
                  props.selectResource(value, "SUSPEND")
                }
                size="small"
                getOptionLabel={(option) => option.resourceName}
                value={props.selectedSuspendResource}
                style={{ marginTop: "10px" }}
                disabled={props.readonly}
                classes={{
                  option: classes.autoCompleteOption,
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("SELECT_SUSPEND_RESOURCE")}
                    variant="outlined"
                  />
                )}
              />

              {props.suspendConnectionFields && (
                <>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    ></Grid>

                    {props.suspendConnectionFields &&
                      Object.keys(props.suspendConnectionFields).map(
                        (key, index) => (
                          <React.Fragment key={index}>
                            <Grid
                              item
                              size={{
                                xs: 12,
                              }}
                            >
                              {index === 0 && (
                                <label style={{ fontSize: "14px" }}>
                                  {t("CONNECTION_PARAMETERS")}
                                </label>
                              )}
                              {key.includes("Password") ? (
                                <FormControl
                                  variant="outlined"
                                  size={"small"}
                                  style={{ marginTop: "6px" }}
                                  className="custom-select-input"
                                >
                                  <InputLabel htmlFor="outlined-adornment-password">
                                    {key}
                                  </InputLabel>
                                  <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={
                                      showPasswordSuspend ? "text" : "password"
                                    }
                                    name={key}
                                    value={props.suspendConnectionFields[key]}
                                    onChange={(event) =>
                                      props.updateConnectionFields(
                                        event,
                                        "SUSPEND",
                                      )
                                    }
                                    disabled={props.readonly}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          onClick={() =>
                                            handleClickShowPassword(2)
                                          }
                                          onMouseDown={handleMouseDownPassword}
                                          edge="end"
                                        >
                                          {showPasswordSuspend ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              ) : (
                                <Input
                                  name={key}
                                  variant={"outlined"}
                                  onChange={(event) =>
                                    props.updateConnectionFields(
                                      event,
                                      "SUSPEND",
                                    )
                                  }
                                  placeholder={key}
                                  size={"small"}
                                  value={props.suspendConnectionFields[key]}
                                  style={{ marginTop: "6px" }}
                                  disabled={props.readonly}
                                />
                              )}
                            </Grid>
                          </React.Fragment>
                        ),
                      )}

                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    ></Grid>
                  </Grid>
                </>
              )}
              {props.suspendTableFields.length > 0 && (
                <Grid container>
                  <ActivationResourcesTable
                    activationParams={props.suspendTableFields}
                    activationParamEditable={props.suspendTableEditable}
                    addActivationParam={addSuspendTableRow}
                    changeActivationParam={updateSuspendTableData}
                    removeActivationParam={removeSuspendTableRow}
                    showDefaultValue={props.showDefaultValue}
                    type={"Suspend"}
                    readonly={props.readonly}
                  />
                </Grid>
              )}
            </Paper>
          </Grid>
          <Grid
            item
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Paper className={classes.componentDialogPaper} elevation={0}>
              <label style={{ fontSize: "14px" }}>
                {t("CONFIGURE_RESUME_RESOURCE")}
              </label>
              <Autocomplete
                options={
                  props.readonly
                    ? props.selectedResumeResource
                    : props.resumeResources
                }
                onChange={(event, value) =>
                  props.selectResource(value, "RESUME")
                }
                size="small"
                getOptionLabel={(option) => option.resourceName}
                value={props.selectedResumeResource}
                style={{ marginTop: "10px" }}
                classes={{
                  option: classes.autoCompleteOption,
                }}
                disabled={
                  !props.selectedSuspendResource.resourceId || props.readonly
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("SELECT_RESUME_RESOURCE")}
                    variant="outlined"
                  />
                )}
              />

              {props.resumeConnectionFields && (
                <>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    ></Grid>

                    {props.resumeConnectionFields &&
                      Object.keys(props.resumeConnectionFields).map(
                        (key, index) => (
                          <React.Fragment key={index}>
                            <Grid
                              item
                              size={{
                                xs: 12,
                              }}
                            >
                              {index === 0 && (
                                <label style={{ fontSize: "14px" }}>
                                  {t("CONNECTION_PARAMETERS")}
                                </label>
                              )}
                              {key.includes("Password") ? (
                                <FormControl
                                  variant="outlined"
                                  size={"small"}
                                  style={{ marginTop: "6px" }}
                                  className="custom-select-input"
                                >
                                  <InputLabel htmlFor="outlined-adornment-password">
                                    {key}
                                  </InputLabel>
                                  <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={
                                      showPasswordResume ? "text" : "password"
                                    }
                                    name={key}
                                    value={props.resumeConnectionFields[key]}
                                    onChange={(event) =>
                                      props.updateConnectionFields(
                                        event,
                                        "RESUME",
                                      )
                                    }
                                    disabled={props.readonly}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          onClick={() =>
                                            handleClickShowPassword(3)
                                          }
                                          onMouseDown={handleMouseDownPassword}
                                          edge="end"
                                        >
                                          {showPasswordResume ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              ) : (
                                <Input
                                  name={key}
                                  variant={"outlined"}
                                  onChange={(event) =>
                                    props.updateConnectionFields(
                                      event,
                                      "RESUME",
                                    )
                                  }
                                  placeholder={key}
                                  size={"small"}
                                  value={props.resumeConnectionFields[key]}
                                  style={{ marginTop: "6px" }}
                                  disabled={props.readonly}
                                />
                              )}
                            </Grid>
                          </React.Fragment>
                        ),
                      )}

                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    ></Grid>
                  </Grid>
                </>
              )}
              {props.resumeTableFields.length > 0 && (
                <Grid container>
                  <ActivationResourcesTable
                    activationParams={props.resumeTableFields}
                    activationParamEditable={props.resumeTableEditable}
                    addActivationParam={addResumeTableRow}
                    changeActivationParam={updateResumeTableData}
                    removeActivationParam={removeResumeTableRow}
                    showDefaultValue={props.showDefaultValue}
                    type={"Resume"}
                    readonly={props.readonly}
                  />
                </Grid>
              )}
            </Paper>
          </Grid>
        </>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ConfigurationResource),
);
